import LayoutMaster from "components/layout/layout_master";
import { MaxButton, StatusMaxButton } from "components/view/button";
import HistoryAccountShow from "components/view/history_account_show";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import get_transaction_history_deposit_and_withdraw, {
  GetTransactionHistoryDepositAndWithdrawResponse,
} from "lib/worker/api/get_transaction_history_deposit_and_withdraw";
import { prefix } from "lib/worker/client";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

interface TransactionTransferProps {
  state: AppReducerStateProps;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function TransactionTransfer(props: TransactionTransferProps) {
  const { transactionDepositAndWithdraw } = props.state.member;
  const router = useRouter();
  const [lineid, setlineid] = useState<string | null | undefined>(null);

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: props.infomation.domain });
    setlineid(infomations.lineidchat);

    if (props.isLogin) {
      reload(true);
    }
  }, []);

  const reload = (re: boolean) => {
    get_transaction_history_deposit_and_withdraw({
      box: re ? [] : transactionDepositAndWithdraw,
      start: re ? 0 : transactionDepositAndWithdraw.length,
      limit: 100,
    });
  };

  const title = (transactionTypeName: string): string => {
    switch (transactionTypeName ?? "") {
      case "deposit":
        return "ฝาก";
      case "withdraw":
        return "ถอน";
      default:
        return "";
    }
  };

  const displayStatus = (
    v: GetTransactionHistoryDepositAndWithdrawResponse
  ): string => {
    if (v.Reject) {
      return "ยกเลิก";
    }
    if (v.Uncalculated) {
      return "สำเร็จ";
    } else {
      return "กำลังดำเนินการ";
    }
  };

  const displayColorAmount = (
    v: GetTransactionHistoryDepositAndWithdrawResponse
  ): string => {
    if (v.Reject) {
      return "#cccccc";
    }

    if ((v.Amount ?? 0) < 0) {
      return "red";
    } else {
      return "green";
    }
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "ประวัติ (ฝาก - ถอน)",
        description:
          "ตรวจสอบ ประวัติธุรกรรม ของท่านได้ตลอด ทุกเวลา สะดวกรวดเร็ว",
      }}
      information={props.infomation}
    >
      <div className="children-top-margin-top-10">
        <h1 className="text-center">ประวัติการทำรายการ</h1>
        <div className="container" style={{ paddingTop: 10 }}>
          <div className="card-add-bg">
            <div className="card-table">
              <div
                className="card-add-headings"
                style={{ paddingTop: 10, paddingBottom: 10 }}
              >
                <span className="card-add-heading text-left">วันที่</span>
                <span className="card-add-heading text-center">ฝาก - ถอน</span>
                <span className="card-add-heading">สถานะ</span>

                <span className="card-add-heading text-right">จำนวนเงิน</span>
              </div>
              <div className="line-span" style={{ marginTop: 0 }}></div>
              {transactionDepositAndWithdraw.map((v) => {
                return (
                  <>
                    <HistoryAccountShow
                      Title={title(v.TransactionTypeName ?? "")}
                      Amount={v.Amount}
                      DisplayCreatedAt={v.DisplayCreatedAt}
                      Status={displayStatus(v)}
                      isReject={v.Reject}
                      Color={displayColorAmount(v)}
                    ></HistoryAccountShow>
                  </>
                );
              })}
            </div>
          </div>

          <MaxButton
            title="โหลดเพิ่ม"
            onClick={() => {
              reload(false);
            }}
            className="margin-top-20"
            status={StatusMaxButton.back}
          ></MaxButton>
        </div>
        <h2
          className="font-red margin-top-20 container"
          style={{ fontSize: 16 }}
        >
          *พบปัญหากรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางแชท{" "}
          {router.pathname.includes("contact") == false && (
            <>
              {" "}
              {lineid != null ? (
                <Link href={lineid}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              ) : (
                <Link href={`/contact/${prefix}`}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              )}
            </>
          )}
        </h2>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(TransactionTransfer);
